import { exactRecord, invalid } from "./outbox-status.js";
export function createSettingsQuery(repository) {
    return {
        invalidateOn: ["domain.entity-changed"],
        key: (row) => row.key,
        name: "settings.current.v1",
        run: async (params) => {
            const parsed = parseSettingsQueryParams(params);
            const rows = await repository.list();
            if (parsed.keys === undefined)
                return rows;
            const keys = new Set(parsed.keys);
            return rows.filter((row) => keys.has(row.key));
        },
    };
}
export function parseSettingsQueryParams(value) {
    const record = exactRecord(value, ["keys"], "settings");
    if (record.keys === undefined)
        return {};
    if (!Array.isArray(record.keys) || !record.keys.every((key) => typeof key === "string")) {
        invalid("settings");
    }
    return { keys: record.keys };
}
//# sourceMappingURL=settings.js.map